<div class="configuration-portal-shell">
  @if (mobileSidebarOpen) {
    <button
      type="button"
      class="configuration-portal-shell__backdrop"
      aria-label="Close sidebar"
      (click)="closeMobileSidebar()"
    ></button>
  }

  <aside
    class="configuration-portal-shell__sidebar"
    [class.configuration-portal-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.configuration-portal-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="configuration-portal-shell__content">
    <app-dashboard-header
      [title]="''"
      [subtitle]="''"
      [user]="user"
      [currentTime]="''"
      (menuToggle)="handleMenuToggle()"
    />

    <main class="configuration-portal-page">
      <section class="configuration-portal-page__panel app-card">
        <div class="configuration-portal-page__panel-header">
          <div class="configuration-portal-page__heading-copy">
            <h2 class="app-title-serif">Configuration Portal</h2>
          </div>

          <button
            type="button"
            class="app-button app-button--primary configuration-portal-page__add-button"
            (click)="openAddVariableModal()"
          >
            <span class="configuration-portal-page__add-icon">+</span>
            <span>Add New Variable</span>
          </button>
        </div>

        <div class="configuration-portal-page__panel-body">
          <form class="configuration-portal-filters row g-3 align-items-end" [formGroup]="filterForm">
            <label class="app-form-field configuration-portal-filters__field configuration-portal-filters__field--search col-12 col-md-6 col-lg-4 col-xxl-2">
              <span class="app-form-label">Search</span>
              <div class="input-group configuration-portal-filters__search">
                <span class="input-group-text configuration-portal-filters__search-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="7"></circle>
                    <path d="m20 20-3.5-3.5"></path>
                  </svg>
                </span>
                <input class="form-control app-form-input configuration-portal-filters__search-input" type="text" placeholder="Search" formControlName="search" />
              </div>
            </label>

            <div class="col-auto ms-auto app-filter-actions">
              <button
                type="button"
                class="app-button app-button--secondary app-filter-actions__button"
                [disabled]="isLoading"
                (click)="clearFilters()"
              >
                Clear
              </button>
            </div>
          </form>

          <div class="configuration-portal-page__table-wrap app-table-scroll">
            <table class="configuration-portal-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Variable Name</th>
                  <th>Variable Value</th>
                  <th>Description</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @if (portalSettings.length > 0) {
                  @for (setting of portalSettings; track trackBySettingId($index, setting)) {
                    <tr>
                      <td>{{ $index + 1 }}</td>
                      <td>{{ setting.variable_name }}</td>
                      <td>{{ setting.variable_value }}</td>
                      <td>{{ setting.description || '-' }}</td>
                      <td>
                        <div class="configuration-portal-page__actions">
                          <div class="app-row-action-menu">
                            <details class="app-row-action-menu__details">
                              <summary class="app-row-action-menu__toggle" aria-label="Open variable actions">
                                <span class="app-row-action-menu__dots" aria-hidden="true">
                                  <span></span>
                                  <span></span>
                                  <span></span>
                                </span>
                              </summary>
                              <div class="app-row-action-menu__dropdown">
                                <button
                                  type="button"
                                  class="app-row-action-menu__item app-row-action-menu__item--view"
                                  (click)="openViewVariableModal(setting)"
                                >
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--view" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M2.5 12s3.5-6.5 9.5-6.5S21.5 12 21.5 12s-3.5 6.5-9.5 6.5S2.5 12 2.5 12Z"></path>
                                      <circle cx="12" cy="12" r="2.8"></circle>
                                    </svg>
                                  </span>
                                  <span>View</span>
                                </button>
                                <button
                                  type="button"
                                  class="app-row-action-menu__item app-row-action-menu__item--edit"
                                  (click)="openEditVariableModal(setting)"
                                >
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--edit" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="m4 20 4.5-1 11-11a2.1 2.1 0 0 0-3-3l-11 11L4 20Z"></path>
                                      <path d="m13.5 6.5 4 4"></path>
                                    </svg>
                                  </span>
                                  <span>Edit</span>
                                </button>
                                <button
                                  type="button"
                                  class="app-row-action-menu__item app-row-action-menu__item--danger app-row-action-menu__item--delete"
                                  (click)="openDeleteVariableModal(setting)"
                                >
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--delete" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M3 6h18"></path>
                                      <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
                                      <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
                                      <path d="M10 10v6"></path>
                                      <path d="M14 10v6"></path>
                                    </svg>
                                  </span>
                                  <span>Delete</span>
                                </button>
                              </div>
                            </details>
                          </div>
                        </div>
                      </td>
                    </tr>
                  }
                  @if (isLoading) {
                    <tr>
                      <td colspan="5" class="configuration-portal-page__empty-state">Refreshing configuration variables...</td>
                    </tr>
                  }
                } @else if (isLoading) {
                  <tr>
                    <td colspan="5" class="configuration-portal-page__empty-state">Loading configuration variables...</td>
                  </tr>
                } @else {
                  <tr>
                    <td colspan="5" class="configuration-portal-page__empty-state">No configuration variables found.</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          @if (canShowPagination()) {
            <div class="configuration-portal-page__pagination">
              <div class="configuration-portal-page__pagination-summary">
                <span>{{ getPaginationLabel() }}</span>
              </div>

              <div class="configuration-portal-page__pagination-actions">
                <button
                  type="button"
                  class="app-button app-button--secondary configuration-portal-page__pagination-button"
                  [disabled]="pagination.page_no <= 1 || isLoading"
                  (click)="goToPreviousPage()"
                >
                  Previous
                </button>

                <div class="configuration-portal-page__pagination-pages" aria-label="Pagination pages">
                  @for (page of getPaginationItems(); track $index) {
                    @if (page === -1) {
                      <span class="configuration-portal-page__pagination-ellipsis" aria-hidden="true">...</span>
                    } @else {
                      <button
                        type="button"
                        class="configuration-portal-page__pagination-page"
                        [class.configuration-portal-page__pagination-page--active]="pagination.page_no === page"
                        [disabled]="isLoading"
                        (click)="goToPage(page)"
                      >
                        {{ page }}
                      </button>
                    }
                  }
                </div>

                <button
                  type="button"
                  class="app-button app-button--secondary configuration-portal-page__pagination-button"
                  [disabled]="pagination.page_no >= pagination.total_pages || isLoading || pagination.total_pages === 0"
                  (click)="goToNextPage()"
                >
                  Next
                </button>
              </div>

              <label class="configuration-portal-page__pagination-size">
                <span class="configuration-portal-page__pagination-size-label">Rows per page</span>
                <select class="app-form-select configuration-portal-page__pagination-select" [formControl]="pageSizeControl">
                  @for (size of pageSizeOptions; track size) {
                    <option [ngValue]="size">{{ size }}/Page</option>
                  }
                </select>
              </label>
            </div>
          }
        </div>
      </section>
    </main>
  </div>

  @if (isVariableModalOpen) {
    <div class="app-modal-backdrop">
      <dialog class="app-modal manage-entity-modal" open>
        <div class="manage-entity-modal__header">
          <div>
            <h3 class="app-title-serif">{{ modalMode === 'edit' ? 'Edit Variable' : modalMode === 'view' ? 'View Variable' : 'Add New Variable' }}</h3>
          </div>

          <button
            type="button"
            class="app-button app-button--icon manage-entity-modal__close"
            aria-label="Close modal"
            (click)="closeVariableModal()"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round">
              <path d="M6 6 18 18"></path>
              <path d="M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <form [formGroup]="portalForm" (ngSubmit)="saveVariable()">
          <div class="manage-entity-modal__body">
            <div class="manage-entity-modal__grid">
              <label class="app-form-field">
                <span class="app-form-label">Variable Name <span class="manage-entity-modal__required">*</span></span>
                <input class="app-form-input" type="text" placeholder="Enter variable name" formControlName="variable_name" />
                @if (isRequiredFieldInvalid('variable_name')) {
                  <section class="app-form-error">Variable name is required</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Variable Value <span class="manage-entity-modal__required">*</span></span>
                <input class="app-form-input" type="text" placeholder="Enter variable value" formControlName="variable_value" />
                @if (isRequiredFieldInvalid('variable_value')) {
                  <section class="app-form-error">Variable value is required</section>
                }
              </label>

              <label class="app-form-field manage-entity-modal__field--full">
                <span class="app-form-label">Description</span>
                <input class="app-form-input" type="text" placeholder="Enter description" formControlName="description" />
              </label>
            </div>
          </div>

          <div class="manage-entity-modal__footer">
            <button type="button" class="app-button app-button--secondary" (click)="closeVariableModal()">Cancel</button>
            @if (modalMode !== 'view') {
              <button type="submit" class="app-button app-button--primary" [disabled]="isSubmitting">
                {{ isSubmitting ? 'Saving...' : 'Save' }}
              </button>
            }
          </div>
        </form>
      </dialog>
    </div>
  }

  @if (isDeleteModalOpen && selectedSetting) {
    <div class="app-modal-backdrop">
      <section class="app-modal app-modal--compact manage-entity-delete">
        <div class="manage-entity-delete__header">
          <div class="manage-entity-delete__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10 11v5"></path>
              <path d="M14 11v5"></path>
              <path d="M3 6h18"></path>
              <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
              <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
            </svg>
          </div>

          <div>
            <h3 class="app-title-serif">Delete Variable</h3>
            <p>This action will remove the configuration variable</p>
          </div>
        </div>

        <p class="manage-entity-delete__copy">
          Are you sure you want to delete <strong>{{ selectedSetting.variable_name }}</strong>?
        </p>

        <div class="manage-entity-delete__footer">
          <button type="button" class="app-button app-button--secondary" (click)="closeDeleteModal()">Cancel</button>
          <button type="button" class="app-button app-button--danger" [disabled]="isSubmitting" (click)="confirmDelete()">
            {{ isSubmitting ? 'Deleting...' : 'Confirm Delete' }}
          </button>
        </div>
      </section>
    </div>
  }
</div>
